import { render, staticRenderFns } from "./AIRecognition.vue?vue&type=template&id=6670b6e6&scoped=true"
import script from "./AIRecognition.vue?vue&type=script&lang=js"
export * from "./AIRecognition.vue?vue&type=script&lang=js"
import style0 from "./AIRecognition.vue?vue&type=style&index=0&id=6670b6e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670b6e6",
  null
  
)

export default component.exports